import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";
import { createStyles } from "@mui/styles";

const ChartFiltersStyles = makeStyles((theme: Theme) =>
    createStyles({
        filtersWrapper: {
            flex: 1,
            display: "flex",
            alignItems: "flex-end",
            marginRight: theme.spacing(2),
            "& > div": {
                display: "flex",
                flex: 1,
                alignItems: "flex-start",
                flexDirection: "column",
            },
        },
        filterPlaceholderLabel: {
            color: theme.palette.text.disabled,
        },
        infoIcon: {
            margin: theme.spacing(0, 0.5, 0.5, 0),
        },
        label: {
            fontSize: 14,
            fontWeight: 500,
            color: theme.palette.text.primary,
            marginBottom: theme.spacing(0.5),
        },
        mainWrapper: {
            backgroundColor: theme.palette.background.grey,
            padding: theme.spacing(1),
        },
        pillContainer: {
            display: "flex",
            alignItems: "center",
            overflow: "hidden",
        },
        pillCounter: {
            width: 20,
            height: 20,
            borderRadius: "40px",
            backgroundColor: theme.palette.info.main,
            color: theme.palette.common.white,
            fontSize: 8,
            fontWeight: 600,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginLeft: theme.spacing(0.5),
            flex: "0 0 auto",
        },
        savedFiltersWrapper: {
            display: "flex",
            flex: 1,
            alignItems: "flex-start",
            flexDirection: "column",
        },
        selectField: {
            width: "100%",
            "& .MuiSelect-select": {
                paddingTop: theme.spacing(2.7),
                paddingBottom: theme.spacing(2.7),
                "& .MuiChip-root": {
                    height: 24,
                    "& .MuiChip-label": {
                        fontSize: 12,
                        paddingLeft: theme.spacing(0.5),
                        paddingRight: theme.spacing(0.5),
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        flexGrow: 1,
                    },
                },
            },
            "& .MuiSelect-icon": {
                fontSize: 16,
                right: theme.spacing(2),
            },
        },
        selectFilterPaper: {
            borderRadius: theme.spacing(4),
            border: `1px solid ${theme.palette.secondary.light}`,
            boxShadow: "0px 1px 3px 0px #0000001A, 0px 1px 2px 0px #0000000F",
        },
        selectMenuItem: {
            "& .MuiListItemText-primary": {
                width: "100%",
                fontSize: 16,
                fontWeight: 400,
                color: theme.palette.text.primary,
            },
            "&.Mui-selected": {
                "& .MuiListItemText-primary": {
                    fontWeight: 700,
                },
            },
        },
        selectMenuClear: {
            display: "flex",
            justifyContent: "flex-end",
            padding: theme.spacing(0, 3, 2, 3),
        },
    })
);

export default ChartFiltersStyles;
